import { updateCurrentPage } from "./../../SiteLayout/CurrentPage/action-creators";
import { getJson, post, postJson } from "Shared/server";
import { setFeedback } from "./../../SiteLayout/GenericFeedbackBar/action-creators";
import { translate } from "Shared/translate";
import { isFavoritesPage, isPantriesPage } from "./current-page-is";
import { epiPropertyValue } from "@avensia/nitro5-scope-episerver";
import { replaceState } from "Shared/history";
export const INIT_ORDER = "INIT_ORDER";
export const INIT_DIALOG_LISTS = "INIT_DIALOG_LISTS";
export const ADD_ORDER_TO_CART = "ADD_ORDER_TO_CART";
export const UPDATE_ITEM = "UPDATE_ITEM";
export const CLEAR_ITEMS = "CLEAR_ITEMS";
export const TOGGLE_LIST_NAME_EDITING = "TOGGLE_LIST_NAME_EDITING";
export function addOrderToCart() {
    return (dispatch, getState) => {
        dispatch({
            type: ADD_ORDER_TO_CART,
        });
    };
}
export function initList(dialog) {
    return {
        type: INIT_DIALOG_LISTS,
        dialog,
    };
}
export function initOrder(products) {
    return {
        type: INIT_ORDER,
        products,
    };
}
export function updateItem(productId, item) {
    return {
        type: UPDATE_ITEM,
        productId,
        item,
    };
}
export function clearItems() {
    return {
        type: CLEAR_ITEMS,
    };
}
export const sortLists = (a, b) => a.displayName.toLocaleLowerCase() > b.displayName.toLocaleLowerCase()
    ? 1
    : a.displayName.toLocaleLowerCase() < b.displayName.toLocaleLowerCase()
        ? -1
        : 0;
const SORT_TITLE_DESC = "SORT_TITLE_DESC";
const SORT_TITLE_ASC = "SORT_TITLE_ASC";
const SORT_ARTNR_DESC = "SORT_ARTNR_DESC";
const SORT_ARTNR_ASC = "SORT_ARTNR_ASC";
const SORT_CUSTOMORDER_DESC = "SORT_CUSTOMORDER_DESC";
const SORT_CUSTOMORDER_ASC = "SORT_CUSTOMORDER_ASC";
const SORT_AREA_DESC = "SORT_AREA_DESC";
const SORT_AREA_ASC = "SORT_AREA_ASC";
export const DEFAULT_SORT = SORT_CUSTOMORDER_DESC;
export const SortOrder = {
    SORT_TITLE_DESC,
    SORT_TITLE_ASC,
    SORT_ARTNR_DESC,
    SORT_ARTNR_ASC,
    SORT_CUSTOMORDER_DESC,
    SORT_CUSTOMORDER_ASC,
    SORT_AREA_DESC,
    SORT_AREA_ASC,
};
const customSort = (sortBy, first, second) => {
    const a = sortBy === SORT_CUSTOMORDER_DESC ? first : second;
    const b = sortBy === SORT_CUSTOMORDER_DESC ? second : first;
    let result = (a.ordinal == null || a.ordinal <= 0) &&
        (b.ordinal == null || b.ordinal <= 0)
        ? 0
        : a.ordinal == null || a.ordinal <= 0
            ? 1
            : b.ordinal == null || b.ordinal <= 0
                ? -1
                : a.ordinal > b.ordinal
                    ? 1
                    : a.ordinal < b.ordinal
                        ? -1
                        : 0;
    if (result === 0) {
        result = SORT_CUSTOMORDER_DESC
            ? a.title.localeCompare(b.title, "sv", { sensitivity: "accent" })
            : b.title.localeCompare(a.title, "sv", { sensitivity: "accent" });
    }
    return result;
};
const lower = (str) => {
    return (str == null ? "" : str).toLocaleLowerCase();
};
export const sortFuncs = {
    [SORT_TITLE_ASC]: (a, b) => b.title.localeCompare(a.title, "sv", { sensitivity: "accent" }),
    [SORT_TITLE_DESC]: (a, b) => a.title.localeCompare(b.title, "sv", { sensitivity: "accent" }),
    [SORT_ARTNR_ASC]: (a, b) => a.code > b.code ? -1 : a.code < b.code ? 1 : 0,
    [SORT_ARTNR_DESC]: (a, b) => a.code > b.code ? 1 : a.code < b.code ? -1 : 0,
    [SORT_CUSTOMORDER_DESC]: (a, b) => customSort(SORT_CUSTOMORDER_DESC, a, b),
    [SORT_CUSTOMORDER_ASC]: (a, b) => customSort(SORT_CUSTOMORDER_ASC, a, b),
    [SORT_AREA_ASC]: (a, b) => lower(a.area) > lower(b.area) ? -1 : lower(a.area) < lower(b.area) ? 1 : 0,
    [SORT_AREA_DESC]: (a, b) => lower(a.area) > lower(b.area) ? 1 : lower(a.area) < lower(b.area) ? -1 : 0,
};
export const setSpinner = (listId) => updateCurrentPage((current) => Object.assign(current, {
    lists: current.lists.map((list) => listId !== list.id
        ? list
        : Object.assign({}, list, {
            isLoading: true,
        })),
}));
export const createNewList = (displayName) => (dispatch, getState) => {
    const url = isFavoritesPage(getState())
        ? `${getState().appShellData.siteSettings.favoriteOverviewPage.url}/create`
        : `${getState().appShellData.siteSettings.pantryOverviewPage.url}/create`;
    return postJson(`${url}?displayName=${encodeURIComponent(validateDisplayName(displayName))}`)
        .then((result) => {
        if (result.success) {
            dispatch(updateCurrentPage((current) => Object.assign(current, { lists: [...current.lists, result.value].sort(sortLists) })));
            dispatch(setFeedback({ text: result.message, type: "success" }));
            return Promise.resolve();
        }
        else {
            dispatch(setFeedback({
                text: result.message
                    ? result.message
                    : translate("/Errors/Unknown"),
                type: "error",
            }));
            return Promise.reject(result.message);
        }
    })
        .catch(failedPromiseHandler);
};
const insertListFromResponse = (list, res) => Object.assign({}, list, res, {
    sortBy: DEFAULT_SORT,
    products: res.products
        .map((item) => Object.assign({}, item))
        .sort(sortFuncs[list.sortBy || DEFAULT_SORT]),
    isLoaded: true,
    isLoading: false,
    selected: list.selected,
});
function updateProductInList(currentList, products) {
    products.forEach((product) => {
        const index = currentList.findIndex((p) => p.code === product.code && p.isCustom === product.isCustom);
        if (index !== -1) {
            const current = currentList[index];
            const mergedProduct = Object.assign({}, product, {
                quantity: current.quantity,
                ordinal: current.ordinal,
            });
            currentList.splice(index, 1, mergedProduct);
        }
        else {
            console.error(`Could not find ${product.code}`);
        }
    });
    return currentList;
}
const updatePrices = (listId, updatedProducts) => (dispatch) => dispatch(updateCurrentPage((current) => {
    return editList(current, listId, (list) => {
        return Object.assign({}, list, {
            products: updateProductInList(list.products, updatedProducts),
        });
    });
}, true));
const getPrices = (url, page) => (dispatch) => {
    return getJson(`${url}&page=${page}`)
        .then((res) => {
        if (res.id != null && res.products && res.products.length > 0) {
            dispatch(updatePrices(res.id, res.products));
            dispatch(getPrices(url, ++page));
        }
        else {
            return Promise.reject(`Bad response getting prices for: ${url}&page=${page}`);
        }
    })
        .catch((e) => console.warn(e));
};
export const getDetails = (listId, defaultDisabled = false) => (dispatch, getState) => {
    dispatch(setSpinner(listId));
    const isFavorite = isFavoritesPage(getState());
    const url = isFavorite
        ? `${getState().appShellData.siteSettings.favoriteOverviewPage.url}/details?id=${listId}`
        : `${getState().appShellData.siteSettings.pantryOverviewPage.url}/details?pantryId=${listId}`;
    return getJson(`${url}`)
        .then((res) => {
        dispatch(updateCurrentPage((current) => {
            editList(current, res.id, (list) => insertListFromResponse(list, res));
        }, true));
    })
        .catch(failedPromiseHandler);
};
export const sortList = (listId, order) => (dispatch, getState) => dispatch(updateCurrentPage((current) => editList(current, listId, (list) => Object.assign({}, list, {
    products: list.products.sort(sortFuncs[order]),
    sortBy: order,
})), true));
export const updateUnit = (listId, code, selectedVariant) => (dispatch, getState) => dispatch(updateCurrentPage((current) => editProductInList(current, listId, (product) => Object.assign({}, product, { selectedVariant }), code), true));
export const updateQuantity = (listId, code, quantity) => (dispatch, getState) => dispatch(updateCurrentPage((current) => editProductInList(current, listId, (product) => Object.assign({}, product, { quantity }), code), true));
export const updateOrdinal = (listId, code, ordinal) => (dispatch, getState) => dispatch(updateCurrentPage((current) => {
    editProductInList(current, listId, (product) => Object.assign({}, product, { ordinal }), code);
}, true));
export const resetList = (listId) => (dispatch, getState) => dispatch(updateCurrentPage((current) => editProductInList(current, listId, (product) => {
    return !!product.quantity
        ? Object.assign({}, product, { quantity: null })
        : product;
}), true));
export const searchInList = (listId, input) => (dispatch, getState) => isPantriesPage(getState()) &&
    dispatch(updateCurrentPage((current) => {
        editList(current, listId, (list) => Object.assign({}, list, { searchQuery: input }));
    }, true));
export const toggleListNameEditing = (listId) => ({ type: TOGGLE_LIST_NAME_EDITING, listId });
export const initLists = () => (dispatch, getState) => getJson(`${getState().appShellData.siteSettings.favoriteOverviewPage.url}/dialog`)
    .then((dialog) => dispatch({ type: INIT_DIALOG_LISTS, dialog }))
    .catch(failedPromiseHandler);
export const renameList = (listId, displayName) => (dispatch, getState) => {
    const url = isFavoritesPage(getState())
        ? `${getState().appShellData.siteSettings.favoriteOverviewPage.url}/rename`
        : `${getState().appShellData.siteSettings.pantryOverviewPage.url}/rename`;
    return postJson(url, { listId, displayName })
        .then((result) => {
        if (result.success) {
            dispatch(updateCurrentPage((current) => {
                editList(current, listId, (list) => Object.assign({}, list, { displayName }));
            }, true));
            dispatch(setFeedback({ text: result.message, type: "success" }));
            return Promise.resolve();
        }
        else {
            dispatch(setFeedback({
                text: result.message
                    ? result.message
                    : translate("/Errors/Unknown"),
                type: "error",
            }));
            return Promise.reject(result.message);
        }
    })
        .catch(failedPromiseHandler);
};
export const removeList = (listId) => updateCurrentPage((current) => Object.assign(current, {
    lists: current.lists.filter((list) => list.id !== listId),
}), true);
export const removeListRequest = (listId) => (dispatch, getState) => {
    const url = isFavoritesPage(getState())
        ? `${getState().appShellData.siteSettings.favoriteOverviewPage.url}/delete`
        : `${getState().appShellData.siteSettings.pantryOverviewPage.url}/delete`;
    return postJson(url, listId)
        .then((result) => {
        if (result.success) {
            dispatch(setFeedback({ text: result.message, type: "success" }));
            return Promise.resolve();
        }
        else {
            dispatch(setFeedback({
                text: result.message
                    ? result.message
                    : translate("/Errors/Unknown"),
                type: "error",
            }));
            return Promise.reject(result.message);
        }
    })
        .catch(failedPromiseHandler);
};
export const createListAndAddProduct = (newName, code, isFavorite) => (dispatch, getState) => {
    const url = isFavorite
        ? `${getState().appShellData.siteSettings.favoriteOverviewPage.url}/CreateListAndAddProduct`
        : `${getState().appShellData.siteSettings.pantryOverviewPage.url}/CreateListAndAddProduct`;
    return postJson(url, { newName: validateDisplayName(newName), code })
        .then((res) => {
        if (!res.success) {
            dispatch(setFeedback({
                text: res.message,
                type: "error",
            }));
            return Promise.reject("Failed to create list and add product");
        }
        dispatch(setFeedback({
            text: res.message,
            type: "success",
        }));
        var reloadIconsEvent = new CustomEvent("reloadIcons", { detail: code });
        window.dispatchEvent(reloadIconsEvent);
        return replaceState().then(() => Promise.resolve());
    })
        .catch(failedPromiseHandler);
};
export const addProductToFavoriteList = (listId, code) => (dispatch, getState) => {
    return postJson(`${getState().appShellData.siteSettings.favoriteOverviewPage.url}/addProduct`, { listId, code })
        .then((result) => {
        if (result.success) {
            dispatch(setFeedback({ text: result.message, type: "success" }));
            return replaceState()
                .then(() => {
                var reloadIconsEvent = new CustomEvent("reloadIcons", {
                    detail: code,
                });
                window.dispatchEvent(reloadIconsEvent);
            })
                .then(() => Promise.resolve());
        }
        else {
            dispatch(setFeedback({
                text: result.message
                    ? result.message
                    : translate("/Errors/Unknown"),
                type: "error",
            }));
            return Promise.reject(result.message);
        }
    })
        .catch(failedPromiseHandler);
};
export const addProductToPantryList = (listId, code) => (dispatch, getState) => {
    return postJson(`${getState().appShellData.siteSettings.pantryOverviewPage.url}/addProduct`, { listId, code })
        .then((result) => {
        if (result.success) {
            dispatch(setFeedback({ text: result.message, type: "success" }));
            return replaceState()
                .then(() => {
                var reloadIconsEvent = new CustomEvent("reloadIcons", {
                    detail: code,
                });
                window.dispatchEvent(reloadIconsEvent);
            })
                .then(() => Promise.resolve());
        }
        else {
            dispatch(setFeedback({
                text: result.message
                    ? result.message
                    : translate("/Errors/Unknown"),
                type: "error",
            }));
            return Promise.reject(result.message);
        }
    })
        .catch(failedPromiseHandler);
};
export const addCustomProductToPantryList = (listId, code) => (dispatch, getState) => {
    return postJson(`${getState().appShellData.siteSettings.pantryOverviewPage.url}/addCustomProduct`, { listId, code })
        .then((result) => {
        if (result.success) {
            dispatch(updateCurrentPage((current) => editList(current, listId, (list) => insertListFromResponse(list, result.value)), true));
            dispatch(setFeedback({ text: result.message, type: "success" }));
            return Promise.resolve(result);
        }
        else {
            dispatch(setFeedback({
                text: result.message
                    ? result.message
                    : translate("/Errors/Unknown"),
                type: "error",
            }));
            return Promise.reject(result.message);
        }
    })
        .catch(failedPromiseHandler);
};
export const updateCustomProductsInPantryList = (listId) => (dispatch, getState) => {
    return postJson(`${getState().appShellData.siteSettings.pantryOverviewPage.url}/getPantry`, listId)
        .then((result) => {
        if (result.success) {
            dispatch(updateCurrentPage((current) => editList(current, listId, (list) => insertListFromResponse(list, result.value)), true));
            dispatch(setFeedback({ text: result.message, type: "success" }));
            return Promise.resolve(result);
        }
        else {
            dispatch(setFeedback({
                text: result.message
                    ? result.message
                    : translate("/Errors/Unknown"),
                type: "error",
            }));
            return Promise.reject(result.message);
        }
    })
        .catch(failedPromiseHandler);
};
export const copyToList = (listId, toListId, codes) => (dispatch, getState) => {
    const isFavoritesPageState = isFavoritesPage(getState());
    const url = isFavoritesPageState
        ? `${getState().appShellData.siteSettings.favoriteOverviewPage.url}/copy`
        : `${getState().appShellData.siteSettings.pantryOverviewPage.url}/Copy`;
    return postJson(url, { listId, codes, toListId })
        .then((result) => {
        if (result.success) {
            dispatch(updateCurrentPage((current) => editList(current, toListId, (list) => insertListFromResponse(list, result.value)), true));
            dispatch(setFeedback({ text: result.message, type: "success" }));
            return Promise.resolve();
        }
        else {
            dispatch(setFeedback({
                text: result.message
                    ? result.message
                    : translate("/Errors/Unknown"),
                type: "error",
            }));
            return Promise.reject(result.message);
        }
    })
        .catch(failedPromiseHandler);
};
export const copyToOtherList = (listId, toListId, codes) => (dispatch, getState) => {
    const url = isFavoritesPage(getState())
        ? `${getState().appShellData.siteSettings.favoriteOverviewPage.url}/copyToPantry`
        : `${getState().appShellData.siteSettings.pantryOverviewPage.url}/copyToFavoriteList`;
    return postJson(url, { listId, codes, toListId })
        .then((result) => {
        if (result.success) {
            dispatch(setFeedback({ text: result.message, type: "success" }));
            return Promise.resolve();
        }
        else {
            dispatch(setFeedback({
                text: result.message
                    ? result.message
                    : translate("/Errors/Unknown"),
                type: "error",
            }));
            return Promise.reject(result.message);
        }
    })
        .catch(failedPromiseHandler);
};
export const copyToNewList = (listId, displayName, codes) => (dispatch, getState) => {
    const url = isFavoritesPage(getState())
        ? `${getState().appShellData.siteSettings.favoriteOverviewPage.url}/copyToNew`
        : `${getState().appShellData.siteSettings.pantryOverviewPage.url}/copyToNew`;
    return postJson(url, {
        listId,
        codes,
        displayName: validateDisplayName(displayName),
    })
        .then((result) => {
        if (result.success) {
            dispatch(updateCurrentPage((current) => {
                editList(current, listId, (list) => Object.assign({}, list, { selected: false }));
                dispatch(setFeedback({ text: result.message, type: "success" }));
                return Object.assign(current, {
                    lists: [...current.lists, result.value].sort(sortLists),
                });
            }, true));
            return Promise.resolve();
        }
        else {
            dispatch(setFeedback({
                text: result.message
                    ? result.message
                    : translate("/Errors/Unknown"),
                type: "error",
            }));
            return Promise.reject(result.message);
        }
    })
        .catch(failedPromiseHandler);
};
export const copyToNewOtherList = (listId, displayName, codes) => (dispatch, getState) => {
    const url = isFavoritesPage(getState())
        ? `${getState().appShellData.siteSettings.favoriteOverviewPage.url}/copyToNewPantry`
        : `${getState().appShellData.siteSettings.pantryOverviewPage.url}/copyToNewFavoriteList`;
    return postJson(url, {
        listId,
        codes,
        displayName: validateDisplayName(displayName),
    })
        .then((result) => {
        if (result.success) {
            dispatch(setFeedback({ text: result.message, type: "success" }));
            return Promise.resolve();
        }
        else {
            dispatch(setFeedback({
                text: result.message
                    ? result.message
                    : translate("/Errors/Unknown"),
                type: "error",
            }));
            return Promise.reject(result.message);
        }
    })
        .catch(failedPromiseHandler);
};
export const moveToList = (listId, toListId, itemCodes) => (dispatch, getState) => {
    const url = isFavoritesPage(getState())
        ? `${getState().appShellData.siteSettings.favoriteOverviewPage.url}/move`
        : `${getState().appShellData.siteSettings.pantryOverviewPage.url}/move`;
    const activeList = getState().currentPage.lists.find((list) => list.id === listId);
    const filterCheckedItemsIfSlaveList = (list) => {
        return list.products.filter((item) => {
            if (list.isSubCustomerList) {
                return (!item.isLocked && itemCodes.includes(item.selectedVariant.code));
            }
            else {
                return itemCodes.includes(item.selectedVariant.code);
            }
        });
    };
    const mapItemToCode = filterCheckedItemsIfSlaveList(activeList).map((item) => item.selectedVariant.code);
    const codes = mapItemToCode;
    return postJson(url, { listId, codes, toListId })
        .then((result) => {
        const value = result.value;
        if (result.success) {
            dispatch(updateCurrentPage((current) => {
                editList(current, toListId, (list) => insertListFromResponse(list, value.targetList));
                editList(current, listId, (list) => insertListFromResponse(list, value.fromList));
            }, true));
            dispatch(setFeedback({ text: result.message, type: "success" }));
            return Promise.resolve();
        }
        else {
            dispatch(setFeedback({
                text: result.message
                    ? result.message
                    : translate("/Errors/Unknown"),
                type: "error",
            }));
            return Promise.reject(result.message);
        }
    })
        .catch(failedPromiseHandler);
};
export const moveToNewList = (listId, displayName, itemCodes) => (dispatch, getState) => {
    const url = isFavoritesPage(getState())
        ? `${getState().appShellData.siteSettings.favoriteOverviewPage.url}/moveToNew`
        : `${getState().appShellData.siteSettings.pantryOverviewPage.url}/moveToNew`;
    const activeList = getState().currentPage.lists.find((list) => list.id === listId);
    const filterCheckedItemsIfSlaveList = (list) => {
        return list.products.filter((item) => {
            if (list.isSubCustomerList) {
                return (!item.isLocked && itemCodes.includes(item.selectedVariant.code));
            }
            else {
                return itemCodes.includes(item.selectedVariant.code);
            }
        });
    };
    const mapItemToCode = filterCheckedItemsIfSlaveList(activeList).map((item) => item.selectedVariant.code);
    const codes = mapItemToCode;
    return postJson(url, {
        listId,
        codes,
        displayName: validateDisplayName(displayName),
    })
        .then((result) => {
        if (result.success) {
            if (Object.keys(result.value).length > 0) {
                dispatch(updateCurrentPage((current) => {
                    editList(current, listId, (list) => Object.assign({}, list, {
                        selected: false,
                        products: list.products.filter((product) => !codes.includes(product.selectedVariant.code)),
                    }));
                    return Object.assign(current, {
                        lists: [
                            ...current.lists,
                            result.value.targetList,
                        ].sort(sortLists),
                    });
                }, true));
            }
            dispatch(setFeedback({ text: result.message, type: "success" }));
            return Promise.resolve();
        }
        else {
            dispatch(setFeedback({
                text: result.message
                    ? result.message
                    : translate("/Errors/Unknown"),
                type: "error",
            }));
            return Promise.reject(result.message);
        }
    })
        .catch(failedPromiseHandler);
};
export const removeProductsFromList = (listId, codes) => (dispatch, getState) => {
    const url = isFavoritesPage(getState())
        ? `${getState().appShellData.siteSettings.favoriteOverviewPage.url}/removeProducts`
        : `${getState().appShellData.siteSettings.pantryOverviewPage.url}/removeProducts`;
    return postJson(url, { listId, codes })
        .then((result) => {
        if (!!result.success && result.message)
            dispatch(setFeedback({ text: result.message, type: "success" }));
        else
            dispatch(setFeedback({
                text: result.message
                    ? result.message
                    : translate("/Errors/Unknown"),
                type: "error",
            }));
    })
        .then(() => dispatch(updateCurrentPage((current) => {
        const oldList = current.lists.find((list) => list.id === listId);
        let newList = Object.assign({}, oldList, {
            products: oldList.products.filter((product) => {
                return !codes.some((code) => product.selectedVariant.code === code);
            }),
        });
        newList.isLoaded = newList.products.length > 0;
        newList.count = newList.products.length;
        return editList(current, listId, (list) => newList);
    }, true)))
        .catch(failedPromiseHandler);
};
export const addProductToList = (listId, product, pantry, status) => (dispatch, getState) => {
    const url = !pantry
        ? `${getState().appShellData.siteSettings.favoriteOverviewPage.url}/addproducts`
        : `${getState().appShellData.siteSettings.pantryOverviewPage.url}/addproducts`;
    return postJson(url, { listId, codes: [product.variants[0].code] })
        .then((result) => {
        dispatch(setFeedback({
            text: result.message,
            type: !result.success ? "error" : "success",
        }));
        if (!result.success)
            return Promise.reject(result);
    })
        .then(() => {
        dispatch(updateCurrentPage((current) => {
            const oldList = current.lists.find((list) => list.id === listId);
            let selectedVariant = !!product.selectedVariant
                ? product.selectedVariant
                : product.variants[0];
            let item = Object.assign({}, product, {
                code: epiPropertyValue(product.content.code),
                variants: pantry ? [selectedVariant] : product.variants,
                selectedVariant: selectedVariant,
                isDisabled: pantry && !!status && status !== "ongoing",
                previousQuantity: null,
                previousTotalPrice: 0,
                pantriesList: !!product.pantriesList
                    ? Object.assign(product.pantriesList, {
                        listId: oldList.displayName,
                    })
                    : { listId: oldList.displayName },
            });
            let newList = Object.assign({}, oldList);
            newList.products.unshift(item);
            newList.isLoaded = newList.products.length > 0;
            newList.count = newList.products.length;
            return editList(current, listId, (list) => newList);
        }, true));
        dispatch(getDetails(listId));
    })
        .catch((result) => {
        dispatch(setFeedback({ text: result.message, type: "error" }));
    });
};
export const lockList = (listId, locked) => (dispatch, getState) => {
    const url = isFavoritesPage(getState())
        ? `${getState().appShellData.siteSettings.favoriteOverviewPage.url}/lockFavorites`
        : `${getState().appShellData.siteSettings.pantryOverviewPage.url}/lockPantry`;
    return postJson(url, { listId: listId, locked: locked })
        .then((result) => {
        if (result.success) {
            dispatch(updateCurrentPage((current) => {
                editList(current, listId, (list) => Object.assign({}, list, {
                    isLocked: locked,
                    isShared: true,
                    products: list.products,
                }));
            }, true));
            dispatch(setFeedback({ text: result.message, type: "success" }));
            return Promise.resolve();
        }
        else {
            dispatch(setFeedback({
                text: result.message
                    ? result.message
                    : translate("/Errors/Unknown"),
                type: "error",
            }));
            return Promise.reject(result.message);
        }
    })
        .catch(failedPromiseHandler);
};
export const shareList = (listId) => (dispatch, getState) => {
    const url = isFavoritesPage(getState())
        ? `${getState().appShellData.siteSettings.favoriteOverviewPage.url}/shareFavorites`
        : `${getState().appShellData.siteSettings.pantryOverviewPage.url}/sharePantry`;
    return postJson(url, listId)
        .then((result) => {
        if (result.success) {
            dispatch(updateCurrentPage((current) => {
                editList(current, listId, (list) => Object.assign({}, list, {
                    isLocked: false,
                    isShared: true,
                    products: list.products,
                }));
            }, true));
            dispatch(setFeedback({ text: result.message, type: "success" }));
            return Promise.resolve();
        }
        else {
            dispatch(setFeedback({
                text: result.message
                    ? result.message
                    : translate("/Errors/Unknown"),
                type: "error",
            }));
            return Promise.reject(result.message);
        }
    })
        .catch(failedPromiseHandler);
};
export const print = (listId, sortBy) => (dispatch, getState) => {
    return post(`${getState().appShellData.siteSettings.favoriteOverviewPage.url}/setprintdata`, {
        lists: [{ id: listId, sortBy }],
    }).then(() => {
        const url = window.location.href;
        const absolute = url.substr(0, url.indexOf("/"));
        window.open(`${absolute + getState().appShellData.siteSettings.favoriteOverviewPage.url}/print`, "_blank");
    });
};
function validateDisplayName(displayName) {
    const regex = new RegExp("[ ]{2,}");
    return displayName.replace(regex, " ").trim();
}
function failedPromiseHandler(e) {
    console.error(e);
    return Promise.reject(null);
}
function editProduct(item, productMerger, codes) {
    if (!codes) {
        return productMerger(item);
    }
    else if (Array.isArray(codes) &&
        codes.includes(item.selectedVariant.code)) {
        return productMerger(item);
    }
    else if (item.selectedVariant.code === codes) {
        return productMerger(item);
    }
    return item;
}
function editProductInList(current, listId, productMerger, codes) {
    return editList(current, listId, (list) => {
        return Object.assign({}, list, {
            products: list.products.map((p) => editProduct(p, productMerger, codes)),
        });
    });
}
function editList(currentPage, listId, listMerger) {
    return Object.assign(currentPage, {
        lists: currentPage.lists.map((list) => list.id !== listId ? list : listMerger(list)),
    });
}
